






















































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {IvrMenus} from "@/store/call/ivr_menus/types";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import CallIvrMenusFilter from "@/components/Call/Filters/CallIvrMenusFilter.vue";

@Component({components: {CallIvrMenusFilter, ScrollButton}})
export default class CallIvrMenus extends BaseItemsPage<IvrMenus> {
  @Getter("ivrMenus") ivrMenuResponse!: IvrMenus[];

  is_show_filter = false;
  currentSort = 'id';
  currentSortOrder = 'desc';
  tableFields = [
    'name',
    'path',
    'description'
  ];

  getData(): IvrMenus[] {
    return this.ivrMenuResponse;
  }
}
